import { Navigate } from 'react-router-dom';
import { useAuth } from '@auth';
import { routes } from '@/shared/routes';

interface Props {
  children: React.ReactNode;
}

export default function GuestRoute({ children }: Props) {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={routes.app.root} replace />;
  }

  return <>{children}</>;
}
